import { HashRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Toaster />
    </HashRouter>
  );
}

export default App;
